import dashboardApi from 'services/api/dashboard'

export const getReviewRequests = (startDate, endDate) => {
  return async dispatch => {
    dispatch({
      type: 'GET_REVIEW_REQUESTS_STARTED'
    })

    try {
      const response = await dashboardApi.getReviewsRequests(startDate, endDate)
      dispatch(gotReviewRequests(response))
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: 'GET_REVIEW_REQUESTS_FAILED',
        payload: err
      })
    }
  }
}

export const gotReviewRequests = reviewRequests => ({
  type: 'GOT_REVIEW_REQUESTS',
  payload: {
    reviewRequests
  }
})

export const gotDailyReviews = reviews => ({
  type: 'GOT_DAILY_REVIEWS',
  payload: reviews
})
